import axios from "axios";
import BASE_URL from "@/services/baseUrl";

const authApi = axios.create({
  baseURL: `${BASE_URL}/auth`,
});

export const init = async (username, password) => {
  try {
    const { data } = await authApi.post("/init/", { username, password });
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const confirm = async (sessionId, orgId) => {
  try {
    const { data } = await authApi.post("/confirm/", {
      session_id: sessionId,
      org_uuid: orgId,
    });
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const refresh = async (refreshToken) => {
  try {
    const { data } = await authApi.post("/refresh/", {
      refresh_token: refreshToken,
    });

    return data;
  } catch (error) {
    return { isError: true, error };
  }
};
